import { render, staticRenderFns } from "./BCNetworkConfiguration.vue?vue&type=template&id=ba87b640&scoped=true"
import script from "./BCNetworkConfiguration.vue?vue&type=script&lang=js"
export * from "./BCNetworkConfiguration.vue?vue&type=script&lang=js"
import style0 from "./BCNetworkConfiguration.vue?vue&type=style&index=0&id=ba87b640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba87b640",
  null
  
)

export default component.exports